import * as React from "react";
import * as BusinessLogic from "@/lib/businessLogic";

import "./chevron_list_item.scss";

type Props = {
    icon?: React.ReactNode;
    text: React.ReactNode;
    subtext?: string;
    onClick: React.MouseEventHandler<HTMLDivElement>;
    is_active: boolean;
    className?: string;
    id?: string;
};

const ChevronListItem = ({ id, className, onClick, is_active, subtext, text }: Props) => {
    const isActiveClass = is_active ? "active" : "";

    return (
        <div id={id} className={(className || "") + " chevron-list-item " + isActiveClass} onClick={onClick}>
            <div className="chevron">
                <i className="fas fa-chevron-right"></i>
            </div>
            <div className="text">
                {subtext !== undefined ? (
                    <div>
                        {text}
                        <br />
                        <small>{subtext}</small>
                    </div>
                ) : (
                    text
                )}
            </div>
        </div>
    );
};

const DropdownChevronListItem = ({ id, className, onClick, is_active, icon, text }: Props) => {
    const isActiveClass = is_active ? "active" : "";
    const sys_flag = BusinessLogic.getSysFlag("env");

    return (
        <div
            id={id}
            data-sys-flag={sys_flag}
            className={(className || "") + " dropdown-chevron-list-item " + isActiveClass}
            onClick={onClick}
        >
            <div className="chevron"></div>
            <div className="text">
                {icon}
                <span className="label">{text}</span>
            </div>
        </div>
    );
};

export { DropdownChevronListItem };
export default ChevronListItem;
